/* tslint:disable */

/**
 * grpc/client_data/client-data.service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Currency of an amount.  The numbers are fixed: they match the codes stored in service databases, so changing them would silently reinterpret existing rows.   - CURRENCY_VND: Vietnamese dong, the default currency of the platform.  - CURRENCY_USD: United States dollar.  - CURRENCY_RUB: Russian rouble.
 * @export
 * @enum {string}
 */

export const V1Currency = {
  Unspecified: 'CURRENCY_UNSPECIFIED',
  Vnd: 'CURRENCY_VND',
  Usd: 'CURRENCY_USD',
  Rub: 'CURRENCY_RUB',
} as const

export type V1Currency = (typeof V1Currency)[keyof typeof V1Currency]
